import { TOKEN_KEY } from '@lib/providers/auth';

import {
  ConfirmRecoveryDto,
  GetClanWarDefenseTeamDto,
  GetClanWarProgressDto,
  GetCurrentProgressDto,
  GetDeviceIdDto,
  GetGauntletLineupDto,
  GetGauntletProgressDto,
  GetRecoveryByUsernameDto,
  GetRecoveryMailDto,
  ValidateRecoveryDto,
} from '@services/_api';
import client from '@services/client';

export const getRecoveryEmail = async (body: GetRecoveryMailDto) => {
  return client.api.recoveryAccountControllerGetRecoveryEmail(body);
};

export const getRecoveryByUsername = async (body: GetRecoveryByUsernameDto) => {
  return client.api.recoveryAccountControllerGetRecoveryByUsername({
    username: body.username.toLowerCase(),
    environment: body.environment,
  });
};

export const streamRecoveryByUsername = async (
  body: GetRecoveryByUsernameDto,
  onPlayer: (player: any) => void,
  signal?: AbortSignal,
): Promise<void> => {
  const token = localStorage.getItem(TOKEN_KEY);
  const baseUrl = process.env.REACT_APP_API_ENDPOINT || '';
  const params = new URLSearchParams({
    username: body.username.toLowerCase(),
    environment: body.environment,
  });

  const response = await fetch(
    `${baseUrl}/api/cstool/recovery-account/stream-by-username?${params}`,
    {
      headers: { Authorization: token ? `Bearer ${token}` : '' },
      signal,
    },
  );

  if (!response.ok || !response.body) {
    throw new Error('Failed to stream players');
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();

  const processChunk = async (buffer: string): Promise<void> => {
    const { done, value } = await reader.read();
    if (done) return;

    const next = buffer + decoder.decode(value, { stream: true });
    const lines = next.split('\n');
    const remaining = lines.pop() ?? '';

    lines
      .filter((line) => line.startsWith('data: '))
      .forEach((line) => {
        try {
          onPlayer(JSON.parse(line.slice(6)));
        } catch {
          // skip malformed lines
        }
      });

    return processChunk(remaining);
  };

  return processChunk('');
};

export const validateRecovery = async (body: ValidateRecoveryDto) => {
  return client.api.recoveryAccountControllerValidateRecovery(body);
};

export const confirmRecovery = async (body: ConfirmRecoveryDto) => {
  return client.api.recoveryAccountControllerConfirmRecovery(body);
};

export const getDeviceId = async (body: GetDeviceIdDto) => {
  return client.api.recoveryAccountControllerGetDeviceId(body);
};

export const getCurrentProgress = async (body: GetCurrentProgressDto) => {
  return client.api.recoveryAccountControllerGetCurrentProgress(body);
};

export const getClanWarProgress = async (body: GetClanWarProgressDto) => {
  return client.api.recoveryAccountControllerGetClanWarProgress(body);
};

export const getClanWarDefenseTeam = async (body: GetClanWarDefenseTeamDto) => {
  return client.api.recoveryAccountControllerGetClanWarDefenseTeam(body);
};

export const getGauntletProgress = async (body: GetGauntletProgressDto) => {
  return client.api.recoveryAccountControllerGetGauntletProgress(body);
};

export const getGauntletLineup = async (body: GetGauntletLineupDto) => {
  return client.api.recoveryAccountControllerGetGauntletLineup(body);
};
